import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


function findByKey(key, value) {
  return (item, i) => item[key] === value
}

@Component({
  selector: 'app-cancel-order-status-config',
  templateUrl: './cancel-order-status-config.component.html',
  styles: [
  ],
})

export class CancelOrderStatusConfigComponent implements OnInit {
  @Input() content: any;
  cancelOrderStatusConfigData = '';
  cancelOrderStatusConfigArray = [];
  sentCancelOrderData = [];
  orderedAmountsData = [];
  editIndex = 0;
  time: number
  id = '';
  cancelOrderStatusDetails: any
  statusArray = [];
  fixedCharge: number
  percentage: number

  timeError = '';
  fixError = '';
  percError = '';
  amountsData = [];

  constructor(
    public dialogRef: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.content = JSON.parse(JSON.stringify(this.content));
    this.id = this.content._id
    this.cancelOrderStatusDetails = this.content.cancelOrderDetails
    this.sentCancelOrderData = this.content.sentCancelOrderConfigArray
    this.cancelOrderStatusConfigArray = this.content.cancelOrderStatusConfigArray
    this.statusArray = this.cancelOrderStatusConfigArray;
    const orderAmountData = this.content.orderAmounts;
    this.editIndex = this.content.editIndex
    this.time = this.cancelOrderStatusConfigArray[this.editIndex]['time']
    this.fixedCharge = this.cancelOrderStatusConfigArray[this.editIndex]['fixed_charge'] ? this.cancelOrderStatusConfigArray[this.editIndex]['fixed_charge'] : 0
    this.percentage = this.cancelOrderStatusConfigArray[this.editIndex]['percentage_charge'] ? this.cancelOrderStatusConfigArray[this.editIndex]['percentage_charge'] : 0
    this.statusArray = this.statusArray.filter(obj => obj['time'] != this.time);
    this.amountsData = this.cancelOrderStatusConfigArray[this.editIndex]['amounts'] ? this.cancelOrderStatusConfigArray[this.editIndex]['amounts'] : [];
    this.orderedAmountsData = orderAmountData;
    var data = [];
    // for(let orderAmount in orderAmountData){
    //   const singleData = orderAmountData[orderAmount];
    //   if(this.amounts.indexOf(singleData['id']) === -1){
    //     singleData['checked'] = false;
    //   }
    //   data.push(singleData);
    // }
    // this.orderedAmounts = data;
    // console.log(this.sentCancelOrderData);
    // console.log(this.id);
    // console.log(this.cancelOrderStatusDetails);
  }

  updateCancelOrderStatusConfig(time, fixedCharge, percentage) {
    const checkTime = obj => obj.time == this.time;
    if (!this.statusArray.some(checkTime)) {
      const data = {};
      data['time'] = this.time
      data['fixed_charge'] = this.fixedCharge
      data['percentage_charge'] = this.percentage
      data['amounts'] = this.amountsData;
      data['status'] = this.content['statusID']
      data['_id'] = this.id;
      console.log(data);

      this.dialogRef.close({ success: true,index : this.editIndex, data : data });
    }else{
      this.timeError = "Config Time Already Exist" 
    }
  }
  setValue(key){
    console.log(key);
    if(key === 'fixedCharge' && this.percentage > 0){
      this.fixedCharge = 0
    }
    if(key === 'percentage' && this.fixedCharge > 0){
      this.percentage = 0
    }
  }
  setAmount(data){
    const checked = data.target.checked;
    const value = data.target.value;
    if(checked){
      if(this.amountsData.indexOf(value) === -1){
        this.amountsData.push(value);
      }
    }else{
      this.amountsData.splice(this.amountsData.indexOf(value),1)
    }
  }
  close() {
    this.dialogRef.close({ success: false });
  }
}
